import { render } from "./WalletRefundsPage.vue?vue&type=template&id=924e6884&scoped=true&ts=true"
import script from "./WalletRefundsPage.ts?vue&type=script&lang=ts"
export * from "./WalletRefundsPage.ts?vue&type=script&lang=ts"

import "./WalletRefundsPage.vue?vue&type=style&index=0&id=924e6884&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-924e6884"]])

export default __exports__